<div class="uid-container">
  <mat-toolbar oneTopbar class="unique-top-bar uid-topbar">
    <mat-toolbar-row>
      <button class="one-topbar-close-button" mat-icon-button one-icon-button (click)="oncancelNotification()">
        <mat-icon>close</mat-icon>
      </button>
      <span one-topbar-title>Create local notification</span>
    </mat-toolbar-row>
  </mat-toolbar>

  <one-horizontal-stepper-container class="unique-horizontal-stepper">
    <mat-horizontal-stepper #stepper [labelPosition]="condensed ? 'end' : 'bottom'" [linear]="isLinear" class="unique-mat-stepper">
      <ng-template let-index="index" matStepperIcon="done">
        <span [ngSwitch]="isLinear">
          <mat-icon *ngSwitchCase="true">yes</mat-icon>
          <span *ngSwitchCase="false"></span>
        </span>
      </ng-template>
      <ng-template let-index="index" matStepperIcon="number"> </ng-template>
      <ng-template let-index="index" matStepperIcon="edit"> </ng-template>
      <mat-step *ngFor="let step of stepperConfig">
        <mat-card oneCard one-flat-card *ngTemplateOutlet="step.template"></mat-card>
      </mat-step>
    </mat-horizontal-stepper>

    <ng-template #firstGroup>
      <div style="padding:0 24px 24px 24px">
        <h3 class="unique-mat-heading">Create local notification ID</h3>
        <!-- <p>Choose the countries that your local notification will be sent to.</p> -->
        <p>Choose the countries and notification type for local notification.</p>
        <one-select [formControl]="countriesFormControlOutlinedSmall" [list]="countriesList" [placeholder]="'Choose countries'" [width]="'300px'" appearance="outlined" size="big"></one-select>&nbsp;
        <one-select [formControl]="notificationTypeFormControl" [list]="notificationTypeList" [placeholder]="'Notification type'" [width]="'210px'" appearance="outlined" size="big"></one-select>
        <!-- <p>Choose the notification type.</p>
          <one-select [formControl]="notificationTypeFormControl" [list]="notificationTypeList" [placeholder]="'Notification type'" [width]="'180px'" appearance="outlined" size="big"></one-select> -->
        <div class="uniqueid-dialog-content">
          <p>Choose if your local notification is based on a global notification:</p>
          <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [formControl]="localBasedGlobalNotificationRadioButton" style="margin-bottom: 24px;">
            <mat-radio-button value="local" class="example-radio-button" style="margin-bottom: 26px;">
              This local notification is not based on a global notification.
            </mat-radio-button>

            <mat-radio-button value="global" class="example-radio-button">
              This local notification is based on a global notification.
            </mat-radio-button>
          </mat-radio-group>

          <div [ngStyle]="{ display: localBasedGlobalNotificationRadioButton.value == 'local' ? 'inline-flex' : 'none' }" class="unique-horizontal-stepper-local-Id">
            <label class="unique-horizontal-stepper-local-Id-label">Define a local notification ID:</label>

            <mat-form-field appearance="outline" oneFormField>
              <mat-icon matSuffix class="one-error-validation-icon" *ngIf="localIDformctrl.invalid && localIDformctrl.touched">caution_alarm</mat-icon>
              <mat-label>Local Notification ID</mat-label>

              <input [formControl]="localIDformctrl" min="1" placeholder="Local Notification ID e.g. QN-CPS-2020-001" matInput />
              <button *ngIf="localIDformctrl.value" one-icon-button-flat mat-flat-button matSuffix (click)="localIDformctrl.setValue('')">
                <mat-icon>clear</mat-icon>
              </button>
              <mat-error *ngIf="flagForLocalIdCheck">ID {{ localIDformctrl.value }} is already existing</mat-error>
              <!-- ID 123465 is already existing flagForLocalIdCheck-->
            </mat-form-field>
          </div>
          <div class="unique-horizontal-stepper-local-container" [ngStyle]="{ display: localBasedGlobalNotificationRadioButton.value == 'global' ? 'inline-flex' : 'none' }">
            <mat-form-field oneSearchField oneSearchFieldBorder="squared" oneSearchFieldAppearance="outline" oneSearchFieldSize="slim" class="unique-horizontal-stepper-search">
              <mat-icon matPrefix>
                search
              </mat-icon>
              <input matInput placeholder="Global notification ID e.g. QN-CPS-2020-001" [formControl]="searchNotificationId" />
              <button *ngIf="searchNotificationId.value" one-icon-button-flat mat-flat-button matSuffix (click)="searchNotificationId.setValue('')">
                <mat-icon>clear</mat-icon>
              </button>
            </mat-form-field>
            <!-- <one-select [formControl]="notificationTypeFormControl" [list]="notificationTypeList" [placeholder]="'Notification type'" [width]="width" appearance="outlined" size="big" class="unique-horizontal-stepper-countries-list"></one-select> -->
            <!-- [formControl]="searchFormControl" -->
            <button [disabled]="isDisabledSearch" mat-stroked-button one-secondary-button (click)="onSerach()">
              Search
            </button>
          </div>
        </div>
      </div>
      <!-- [ngStyle]="{'display':localBasedGlobalNotificationRadioButton.value == 'global'?'block':'none'}" -->
      <!-- paginator start -->
      <div class="mat-elevation-z8" [ngStyle]="{ display: isTableShow ? 'block' : 'none' }">
        <div class="unique-horizontal-stepper-table">
          <span>Global notification search results for {{notificationTypeFormControl.value['label']}} notification type</span>
          <span *ngIf="dataFlag">{{ dataSource.data.length }} results</span>
          <span *ngIf="!dataFlag">0 results</span>
        </div>
        <table style="width:100%" mat-table [dataSource]="dataSource" [disabled]="isTableShow" *ngIf="dataSource.data.length > 0 && dataFlag">
          <ng-container matColumnDef="documentTitle">
            <th mat-header-cell *matHeaderCellDef>Document title</th>
            <td style="width: 63%;" mat-cell *matCellDef="let element">{{ element.Title }}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="version">
            <th mat-header-cell *matHeaderCellDef>Version</th>
            <td mat-cell *matCellDef="let element">{{ element.VersionNumber }}</td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="language">
            <th mat-header-cell *matHeaderCellDef>Language</th>
            <td mat-cell *matCellDef="let element">{{ element.Language[0]['IsoCode'] | uppercase }}</td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let element">{{ element.ModifyDate | date: 'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="select" *ngIf="dataSource.data.length > 0">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" style="cursor: pointer;"><mat-icon>create</mat-icon></td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="rowSelection(row)"></tr>
        </table>

        <table style="width:100%" [disabled]="isTableShow" *ngIf="dataSource.data.length == 0" class="no-data-found-table mat-table cdk-table ng-star-inserted">
          <tr class="mat-header-row cdk-header-row ng-star-inserted">
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Document title</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Version</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Language</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Date</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle "></th>
          </tr>
          <tr class="mat-header-row cdk-header-row ng-star-inserted" style="padding-left: 24 px; height: 254px;">
            <td colspan="5" style="align-items: center; justify-content: space-around; text-align: center;">
              <mat-icon svgIcon="no_data_found" style="height: 82px;width:82px;padding-bottom: 24px;"></mat-icon>
              <span style="padding-bottom: 8px;display: block;"> <B>Search error</B> </span>
              <p style="width: 26%; margin: auto;">
                There was an error while running your search. Please try again.
              </p>
            </td>
          </tr>
        </table>

        <table style="width:100%" [disabled]="isTableShow" *ngIf="!dataFlag" class="no-data-found-table mat-table cdk-table ng-star-inserted">
          <tr class="mat-header-row cdk-header-row ng-star-inserted">
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Document title</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Version</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Language</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle ">Date</th>
            <th class="mat-header-cell cdk-header-cell cdk-column-documentTitle mat-column-documentTitle "></th>
          </tr>
          <tr class="mat-header-row cdk-header-row ng-star-inserted" style="padding-left: 24 px; height: 254px;">
            <td colspan="5" style="align-items: center; justify-content: space-around; text-align: center;">
              <p style="width: 26%; margin: auto;">
                No document found for this search text and document type.
              </p>
            </td>
          </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of periodic elements"> </mat-paginator>
      </div>
    </ng-template>

    <ng-template #secondGroup>
      <div style="padding: 0 24px 24px 24px;">
        <h1 i18n="@@input-dialog-example.title">Create local notification</h1>
        <div class="globalid-dialog-content">
          <p>To create the local notification ID, define a suffix to the global notification ID:</p>
          <mat-form-field appearance="outline" oneFormField>
            <mat-label>Global notification ID</mat-label>
            <input matInput value="{{ uniqueID }}" [disabled]="true" />
          </mat-form-field>
          <span class="icon-style">+</span>
          <mat-form-field appearance="outline" oneFormField>
            <mat-icon matSuffix class="one-error-validation-icon" *ngIf="globalIDformctrl.invalid && globalIDformctrl.touched">caution_alarm</mat-icon>
            <mat-label>Suffix</mat-label>
            <!--  (mouseover)="getGlobalID()"  (mouseout)="getGlobalID()" -->
            <input matInput [formControl]="globalIDformctrl" />
            <button mat-icon-button one-icon-button matSuffix class="clear-icon" (click)="globalIDformctrl.setValue('')">
              <mat-icon matSuffix>clear</mat-icon>
            </button>
            <mat-error *ngIf="flagForglobalIdCheck">ID {{ globalIDformctrl.value }} is already existing</mat-error>
          </mat-form-field>
          <p>Local notification ID:<span name="globalID" class="text-id" [innerHTML]="globalID"></span>{{ globalIDformctrl.value }}</p>
        </div>
      </div>
    </ng-template>
  </one-horizontal-stepper-container>

  <mat-toolbar class="unique-top-bar unique-bottom-bar uid-bottom-bar" oneTopbar>
    <mat-toolbar-row class="bottom-bar" style="display:flex;flex-direction: row-reverse !important;">
      <div class="uniqueid-dialog-actions">
        <button one-secondary-button mat-stroked-button i18n="@@input-dialog-example.no-thanks-btn" type="button" style="margin-right: 24px;" (click)="oncancelNotification()">
          Cancel
        </button>
        <!-- [mat-dialog-close]="uniqueIdType" -->
        <button color="primary" [disabled]="isCreateDisabled" (click)="createLocalGlobalId()" mat-flat-button i18n="@@input-dialog-example.ok-btn" type="submit">
          Create
        </button>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
